"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Account = function Account(_ref) {
  var title = _ref.title,
      description = _ref.description,
      width = _ref.width,
      height = _ref.height,
      rest = _objectWithoutProperties(_ref, ["title", "description", "width", "height"]);

  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    "aria-hidden": !title,
    "aria-labelledby": "AccountTitle AccountDescription",
    height: height,
    preserveAspectRatio: "none",
    role: "img",
    viewBox: "0 0 24 24",
    width: width
  }, rest), /*#__PURE__*/_react["default"].createElement("title", {
    id: "AccountTitle"
  }, title), /*#__PURE__*/_react["default"].createElement("desc", {
    id: "AccountDescription"
  }, description), /*#__PURE__*/_react["default"].createElement("defs", null, /*#__PURE__*/_react["default"].createElement("path", {
    transform: "scale(0.75 0.75)",
    d: "M15.951 14.689a4 4 0 1 0 0-8 4 4 0 0 0 0 8zm0-6.853a2.871 2.871 0 1 1 0 5.742 2.871 2.871 0 0 1 0-5.742zm3.142 13.373a1.262 1.262 0 1 1 0 2.524 1.262 1.262 0 0 1 0-2.524zM20.2 17.2a4.151 4.151 0 0 1 4.151 4.147v4.355c-.356.29-.727.562-1.111.814V21.4a3.044 3.044 0 0 0-3.04-3.04h-8.498a3.044 3.044 0 0 0-3.04 3.04v5.116a14.23 14.23 0 0 1-1.11-.814v-4.355a4.151 4.151 0 0 1 4.15-4.147H20.2zM15.951.431C7.497.431.644 7.284.644 15.738c0 8.453 6.853 15.306 15.307 15.306s15.307-6.853 15.307-15.306A15.302 15.302 0 0 0 15.95.43zm0 29.498c-7.83-.017-14.174-6.36-14.191-14.191v-.236c0-7.835 6.352-14.186 14.187-14.186 7.835 0 14.186 6.351 14.186 14.186v.222c-.002 7.838-6.345 14.196-14.182 14.218v-.013z",
    id: "refAccountPoz1S0ftJ6D"
  })), /*#__PURE__*/_react["default"].createElement("use", {
    xlinkHref: "#refAccountPoz1S0ftJ6D"
  }));
};

Account.defaultProps = {
  description: '',
  height: 24,
  title: null,
  width: 24
};
Account.propTypes = {
  description: _propTypes["default"].string,
  height: _propTypes["default"].number,
  title: _propTypes["default"].string,
  width: _propTypes["default"].number
};
var _default = Account;
exports["default"] = _default;